module.exports = __webpack_public_path__ + "static/medical-equipment-c36c9d78c872c64d68e676a6a6168f62.jpg";